/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { CreateEvaluationParameterDto } from './CreateEvaluationParameterDto';
import {
    CreateEvaluationParameterDtoFromJSON,
    CreateEvaluationParameterDtoFromJSONTyped,
    CreateEvaluationParameterDtoToJSON,
} from './CreateEvaluationParameterDto';
import type { ICreateSetupParameterFilter } from './ICreateSetupParameterFilter';
import {
    ICreateSetupParameterFilterFromJSON,
    ICreateSetupParameterFilterFromJSONTyped,
    ICreateSetupParameterFilterToJSON,
} from './ICreateSetupParameterFilter';
import type { TaskTypeDescription } from './TaskTypeDescription';
import {
    TaskTypeDescriptionFromJSON,
    TaskTypeDescriptionFromJSONTyped,
    TaskTypeDescriptionToJSON,
} from './TaskTypeDescription';

/**
 * 
 * @export
 * @interface DataSetRequestDto
 */
export interface DataSetRequestDto {
    /**
     * 
     * @type {string}
     * @memberof DataSetRequestDto
     */
    startDate?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DataSetRequestDto
     */
    endDate?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DataSetRequestDto
     */
    targetSystemIds?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DataSetRequestDto
     */
    supportSystemIds?: Array<string> | null;
    /**
     * 
     * @type {Array<TaskTypeDescription>}
     * @memberof DataSetRequestDto
     */
    selectedTaskTypes?: Array<TaskTypeDescription> | null;
    /**
     * 
     * @type {Array<ICreateSetupParameterFilter>}
     * @memberof DataSetRequestDto
     */
    targetSystemSetupFilters?: Array<ICreateSetupParameterFilter> | null;
    /**
     * 
     * @type {Array<ICreateSetupParameterFilter>}
     * @memberof DataSetRequestDto
     */
    supportSystemSetupFilters?: Array<ICreateSetupParameterFilter> | null;
    /**
     * 
     * @type {Array<CreateEvaluationParameterDto>}
     * @memberof DataSetRequestDto
     */
    evaluationParameterFilters?: Array<CreateEvaluationParameterDto> | null;
    /**
     * 
     * @type {number}
     * @memberof DataSetRequestDto
     */
    maximumDataSetCount?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DataSetRequestDto
     */
    $type?: DataSetRequestDtoTypeEnum;
}


/**
 * @export
 */
export const DataSetRequestDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedResultsDtoDataSetRequestDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.Results.Dto.DataSetRequestDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type DataSetRequestDtoTypeEnum = typeof DataSetRequestDtoTypeEnum[keyof typeof DataSetRequestDtoTypeEnum];


/**
 * Check if a given object implements the DataSetRequestDto interface.
 */
export function instanceOfDataSetRequestDto(value?: unknown): value is DataSetRequestDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(DataSetRequestDtoTypeEnum)[0];
}

export function DataSetRequestDtoFromJSON(json: any): DataSetRequestDto {
    return DataSetRequestDtoFromJSONTyped(json, false);
}

export function DataSetRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DataSetRequestDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'startDate': !exists(json, 'startDate') ? undefined : json['startDate'],
        'endDate': !exists(json, 'endDate') ? undefined : json['endDate'],
        'targetSystemIds': !exists(json, 'targetSystemIds') ? undefined : json['targetSystemIds'],
        'supportSystemIds': !exists(json, 'supportSystemIds') ? undefined : json['supportSystemIds'],
        'selectedTaskTypes': !exists(json, 'selectedTaskTypes') ? undefined : (json['selectedTaskTypes'] === null ? null : (json['selectedTaskTypes'] as Array<any>).map(TaskTypeDescriptionFromJSON)),
        'targetSystemSetupFilters': !exists(json, 'targetSystemSetupFilters') ? undefined : (json['targetSystemSetupFilters'] === null ? null : (json['targetSystemSetupFilters'] as Array<any>).map(ICreateSetupParameterFilterFromJSON)),
        'supportSystemSetupFilters': !exists(json, 'supportSystemSetupFilters') ? undefined : (json['supportSystemSetupFilters'] === null ? null : (json['supportSystemSetupFilters'] as Array<any>).map(ICreateSetupParameterFilterFromJSON)),
        'evaluationParameterFilters': !exists(json, 'evaluationParameterFilters') ? undefined : (json['evaluationParameterFilters'] === null ? null : (json['evaluationParameterFilters'] as Array<any>).map(CreateEvaluationParameterDtoFromJSON)),
        'maximumDataSetCount': !exists(json, 'maximumDataSetCount') ? undefined : json['maximumDataSetCount'],
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function DataSetRequestDtoToJSON(value?: DataSetRequestDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'startDate': value.startDate,
        'endDate': value.endDate,
        'targetSystemIds': value.targetSystemIds,
        'supportSystemIds': value.supportSystemIds,
        'selectedTaskTypes': value.selectedTaskTypes === undefined ? undefined : (value.selectedTaskTypes === null ? null : (value.selectedTaskTypes as Array<any>).map(TaskTypeDescriptionToJSON)),
        'targetSystemSetupFilters': value.targetSystemSetupFilters === undefined ? undefined : (value.targetSystemSetupFilters === null ? null : (value.targetSystemSetupFilters as Array<any>).map(ICreateSetupParameterFilterToJSON)),
        'supportSystemSetupFilters': value.supportSystemSetupFilters === undefined ? undefined : (value.supportSystemSetupFilters === null ? null : (value.supportSystemSetupFilters as Array<any>).map(ICreateSetupParameterFilterToJSON)),
        'evaluationParameterFilters': value.evaluationParameterFilters === undefined ? undefined : (value.evaluationParameterFilters === null ? null : (value.evaluationParameterFilters as Array<any>).map(CreateEvaluationParameterDtoToJSON)),
        'maximumDataSetCount': value.maximumDataSetCount,
        '$type': value.$type,
    });
}

